import { telehealthBaseModel } from './crud';

export * from './types';

export const useTelehealthsById = telehealthBaseModel.fetchById();
export const useTelehealthsByIds = telehealthBaseModel.fetchByIds();
export const useTelehealthsMany = telehealthBaseModel.fetchMany();
export const useTelehealthsCount = telehealthBaseModel.count();
export const useTelehealthsManyInfiniteQuery =
  telehealthBaseModel.fetchPaginated();
export const useTelehealthsUpdateOne = telehealthBaseModel.edit();
export const useTelehealthsCreateOne = telehealthBaseModel.create();
export const useTelehealthsRemoveOne = telehealthBaseModel.delete();
export const useTelehealthsRemoveByIds = telehealthBaseModel.deleteByIds();

export const useTelehealthsByIdV2 = telehealthBaseModel.fetchByIdV2();
export const useTelehealthsByIdsV2 = telehealthBaseModel.fetchByIdsV2();
export const useTelehealthsManyV2 = telehealthBaseModel.fetchManyV2();
export const useTelehealthsCountV2 = telehealthBaseModel.countV2();
export const useTelehealthsManyInfiniteQueryV2 =
  telehealthBaseModel.fetchPaginatedV2();
export const useTelehealthsUpdateOneV2 = telehealthBaseModel.editV2();
export const useTelehealthsCreateOneV2 = telehealthBaseModel.createV2();
export const useTelehealthsRemoveOneV2 = telehealthBaseModel.deleteV2();
export const useTelehealthsRemoveByIdsV2 = telehealthBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useTelehealthById = telehealthBaseModel.fetchById();
export const useTelehealthByIds = telehealthBaseModel.fetchByIds();
export const useTelehealthMany = telehealthBaseModel.fetchMany();
export const useTelehealthCount = telehealthBaseModel.count();
export const useTelehealthPagination = telehealthBaseModel.fetchPaginated();
export const useTelehealthUpdateOne = telehealthBaseModel.edit();
export const useTelehealthCreateOne = telehealthBaseModel.create();
export const useTelehealthRemoveOne = telehealthBaseModel.delete();
export const useTelehealthRemoveByIds = telehealthBaseModel.deleteByIds();

export const useTelehealthByIdV2 = telehealthBaseModel.fetchByIdV2();
export const useTelehealthByIdsV2 = telehealthBaseModel.fetchByIdsV2();
export const useTelehealthManyV2 = telehealthBaseModel.fetchManyV2();
export const useTelehealthCountV2 = telehealthBaseModel.countV2();
export const useTelehealthPaginationV2 = telehealthBaseModel.fetchPaginatedV2();
export const useTelehealthUpdateOneV2 = telehealthBaseModel.editV2();
export const useTelehealthCreateOneV2 = telehealthBaseModel.createV2();
export const useTelehealthRemoveOneV2 = telehealthBaseModel.deleteV2();
export const useTelehealthRemoveByIdsV2 = telehealthBaseModel.deleteByIdsV2();
